import React, { useImperativeHandle, memo, forwardRef } from 'react'
import { CircularProgress } from '@material-ui/core'
import { ThemeProvider } from '@material-ui/core/styles'
import { ParentCover, CenterInParent } from '../styles'
import { busyCursorColorOverride } from '../themes'
import { busyCursorZIndex } from '../common'
import { clearBlocking, setBlocking } from './'
import { useMergeState } from '../hooks'

const LocalBusyCursor = memo(forwardRef((_props, ref) => {
  const [, setState, getState] = useMergeState({ busy: 0 })
  useImperativeHandle(ref, () => ({
    clearBusy: () => {
      const state = getState()
      if (state.busy === 1) {
        clearBlocking()
      }
      setState({ busy: state.busy - 1 })
    },
    setBusy: () => {
      const state = getState()
      if (state.busy === 0) {
        setBlocking()
      }
      setState({ busy: state.busy + 1 })
    },
  }))

  if (getState().busy <= 0) {
    return null
  }

  return (
    <ParentCover zIndex={busyCursorZIndex}>
      <CenterInParent>
        <ThemeProvider theme={innerTheme =>
          busyCursorColorOverride(innerTheme)}>
          <CircularProgress />
        </ThemeProvider>
      </CenterInParent>
    </ParentCover>
  )
}))

export default LocalBusyCursor
